import TableTennisInformation from './TableTennis';

export { TableTennisInformation };
